import { EnumMimeTypes } from '@blank/api'

export const getFileUrl = (
  blob: Blob,
  format: EnumMimeTypes = EnumMimeTypes.PDF
): string => {
  // Create blob link to download or preview
  return URL.createObjectURL(new Blob([blob], { type: format }))
}
